import { Fragment, useContext, useEffect, useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  ChevronRightIcon,
  ArrowLeftIcon,
  UsersIcon
} from "@heroicons/react/24/outline";
import { DisclosureInviteFriendsEmail, DisclosureInviteFriendsQR, DisclosureInviteFriendsWhatsapp } from "./InviteFriendsOptions";
import { APIClient } from "../../../../helpers/api_helper";
import * as url from '../../helpers/url_helper';
import { SuccessViewDisclosure } from "../successView";
import axios from "axios";
import { FriendsList } from "./FriendsList";
import { environment } from "../../../../configs/variables";
import { FriendsViewContext } from "../../../../context/Disclosures/friends/friendsContext";

const apiClient = new APIClient();

export function DisclosureInviteFriends() {
  const { updateFriendsView, friendsViewData } = useContext(FriendsViewContext);
  const [open, setOpen] = useState(false);
  const [emailReferral, setEmailReferral] = useState('');
  const [whatsappInput, setWhatsappInput] = useState('');
  const [showError, setShowError] = useState(true);
  const [showErrorQr, setShowErrorQr] = useState(true);
  const [messageError, setMessageError] = useState('');
  const [messageErrorQr, setMessageErrorQr] = useState('');
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessView, setShowSuccessView] = useState(false);
  const [showQr, setShowQr] = useState(false);
  const [qrCode, setQrCode] = useState('');

  const handleChangeEmail = (e) => {
    const { value } = e.target;
    setEmailReferral(value);
  }

  const handleChangeWhatsapp = (e) => {
    const { value } = e.target;
    setWhatsappInput(value);
  }

  const handleClearDisclosureWa = () => {
    setWhatsappInput('');
    setMessageError('');
    setShowError(false);
    setDisabledBtn(false);
  }

  const handleSendWhatsapp = () => {
    console.log(whatsappInput);
    setShowError(false);
    setMessageError('');

    if (whatsappInput.length === 0) {
      setShowError(true);
      setMessageError("El número no puede estar vacío.");
      return;
    }
    if (whatsappInput === localStorage.getItem('phone')) {
      setShowError(true);
      setMessageError("El número debe ser diferente al que tienes registrado.");
      return;
    }

    if (whatsappInput.length > 10 || whatsappInput.length < 10) {
      setShowError(true);
      setMessageError("El número es inválido.");
      return;
    }

    setDisabledBtn(true);
    let domain = environment === 'LOCAL' || environment === 'DEV' ? 'https://dev.galilea.co:8443' : 'https://galilea.co';
    let referral = `${domain}?utm_id=referido-${localStorage.getItem('doc')}`;
    let urlWhatsapp = `https://api.whatsapp.com/send/?phone=+57${whatsappInput}&text=${referral}%0AEncontré una entidad 100% confiable donde puedes solicitar un crédito de manera segura. Usa este link para que tengas más probabilidades de tener un crédito.`;
    setDisabledBtn(false);
    window.open(urlWhatsapp, '_blank');
    return handleClosePanel();
  }

  const handleClosePanel = () => {
    setOpen(false);
    setEmailReferral("");
    setMessageError("");
    setShowError(false);
    setShowErrorQr(false);
    setMessageErrorQr('')
    setShowQr(false);
    setQrCode('');
    setWhatsappInput('');
  }

  const handleSubmitEmailReferral = async () => {
    setShowError(false);
    setMessageError('');

    const validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;

    if (emailReferral.length === 0) {
      setShowError(true);
      setMessageError("El correo no puede estar vacío.");
      return;
    }
    if (emailReferral === localStorage.getItem('email')) {
      setShowError(true);
      setMessageError("El correo debe ser diferente al que tienes registrado.");
      return;
    }

    if (!validEmail.test(emailReferral)) {
      setShowError(true);
      setMessageError("El correo ingresado no es válido.");
      return;
    }
    setDisabledBtn(true);
    setIsLoading(true);

    try {
      let response = await apiClient.create(url.SEND_MAIL_REFERRAL, { documento: localStorage.getItem('doc'), mailReferrals: emailReferral });
      let { data } = response;
      if (data?.success === false) {
        setMessageError('En este momento no fue posible enviar el correo, intenta más tarde.');
        setShowError(true);
        return;
      }
      setShowSuccessView(true);
    } catch (error) {
      setMessageError('En este momento no fue posible enviar el correo, intenta más tarde.');
      setShowError(true);
      return;
    } finally {
      setDisabledBtn(false);
      setIsLoading(false);
    }
  }

  const handleGenerateQr = async () => {
    setShowErrorQr(false);
    setMessageErrorQr('');
    setIsLoading(true);

    try {
      let response = await axios.post(url.GENERATE_QR_CODE, { documento: localStorage.getItem('doc') });
      let { data } = response;
      if (data?.success === false) {
        setMessageErrorQr('En este momento no fue posible generar el QR, intenta más tarde.');
        setShowErrorQr(true);
        return;
      }
      let _qrCode = data?.qrCode;
      if (_qrCode) {
        setQrCode(_qrCode);
        setShowQr(true);
      }
    } catch (error) {
      setMessageErrorQr('En este momento no fue posible generar el QR, intenta más tarde.');
      setShowErrorQr(true);
    } finally {
      setIsLoading(false);
    }
  }

  const channels = [
    {
      disclosure:
        <DisclosureInviteFriendsWhatsapp
          handleChangeWhatsapp={handleChangeWhatsapp}
          whatsappInput={whatsappInput}
          showError={showError}
          messageError={messageError}
          disabledBtn={disabledBtn}
          showSuccessView={showSuccessView}
          handleClosePanel={handleClosePanel}
          handleSendWhatsapp={handleSendWhatsapp}
          handleClearDisclosureWa={handleClearDisclosureWa}
        />
    },
    {
      disclosure: <DisclosureInviteFriendsQR
        showErrorQr={showErrorQr}
        messageErrorQr={messageErrorQr}
        isLoading={isLoading}
        showQr={showQr}
        qrCode={qrCode}
        handleGenerateQr={handleGenerateQr}
        handleClosePanel={handleClosePanel}
      />,
    },
    {
      disclosure:
        showSuccessView ? <SuccessViewDisclosure
          showSuccessView={showSuccessView}
          handleClosePanel={handleClosePanel}
          dialogTitle={"Invitación enviada"}
          content={"Genial! hemos envíado la invitación exitosamente!"}
        /> :
          <DisclosureInviteFriendsEmail
            handleChangeEmail={handleChangeEmail}
            emailReferral={emailReferral}
            showError={showError}
            messageError={messageError}
            handleSubmitEmailReferral={handleSubmitEmailReferral}
            disabledBtn={disabledBtn}
            isLoading={isLoading}
            showSuccessView={showSuccessView}
            handleClosePanel={handleClosePanel}
          />,
    },
  ];

  const handleOpenDisclosure = () => {
    updateFriendsView({
      openDisclosure: true,
    });
    setOpen(true);
  };

  const handleCloseDisclosure = () => {
    updateFriendsView({
      openDisclosure: false,
    });
    setOpen(false);
  };

  useEffect(() => {
    setOpen(friendsViewData?.openDisclosure);
  }, [friendsViewData?.openDisclosure]);

  return (
    <>
      <div className={"w-full"} onClick={handleOpenDisclosure} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="flex justify-between">
            <div className="flex gap-2 py-1">
              <div className="w-5 h-auto xl:w-6">
                <UsersIcon />{" "}
              </div>
              <div className="xl:hidden">Invitar amigos</div>
            </div>
            <div className="grid content-center xl:hidden">
              <ChevronRightIcon className="w-5 h-auto" />
            </div>
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={handleOpenDisclosure} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-transparent xl:bg-darkBgLight xl:bg-opacity-75 transition-opacity duration-200 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-[closed]:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div className="">
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleCloseDisclosure}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                        <DialogTitle>
                          <div className="text-white">Invitar amigos</div>
                        </DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          <FriendsList />
                        </div>
                      </div>
                      <div className=" px-4 pt-8 ">
                        <div className="text-white font-bold text-xl">
                          Obtén puntos por invitar a tus amigos a Galilea
                        </div>
                        <div className="text-grayP text-sm pt-6">
                          Te damos hasta {"300"} puntos por referir amigos que
                          accedan a un crédito en Galilea y paguen a tiempo sus
                          cuotas. Recuerda que los puntos te ayudan a subir de
                          nivel que a su vez desbloquean descuentos sobre
                          intereses y Firma Electrónica, así como aumentos de
                          cupo
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-white">
                    <div className="text-grayP py-4 px-4">
                      ¿Cómo quieres invitarlos?
                    </div>
                    <div className="">
                      {channels.map((channel, index) => (
                        <Fragment key={'fragment-channel' + index}>
                          <div key={'channel' + index}>
                            <a
                              key={'a-channel' + index}
                              href={channel.href}
                              className="group flex justify-between w-full gap-2 rounded-md px-4 py-6"
                            >
                              {channel.disclosure && (
                                <div className="relative w-full" key={'disclosure' + index}>
                                  {channel.disclosure}
                                </div>
                              )}
                              {channel.name && (
                                <div className="flex w-full gap-2 py-1" key={'div-channel-name' + index}>
                                  <div className="w-5 h-auto" key={'div-channel-icon' + index}>{channel.icon}</div>
                                  <div className="pl-4" key={'div-channel-name-child' + index}>{channel.name}</div>
                                </div>
                              )}

                              {channel.name && (
                                <div className="grid content-center" key={'div-chevron' + index}>
                                  <ChevronRightIcon key={'chevron-right-icon' + index} className="w-5 h-auto" />
                                </div>
                              )}
                            </a>
                          </div>
                        </Fragment >
                      ))}
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
